module.exports = __webpack_public_path__ + "img/120.a491a3f0.jpg";